import { useIsMobile } from '../../lib/useIsMobile';
import { shortUrl } from './helpers';

export function FilterChip({ label, on, onClick }: { label: string; on: boolean; onClick: () => void }) {
  const isMobile = useIsMobile();
  return (
    <button type="button" className={isMobile ? `c${on ? ' on' : ''}` : `chip${on ? ' accent' : ''}`} aria-pressed={on} onClick={onClick}>
      {label}
    </button>
  );
}

export function ExternalLink({ className, href, children }: { className: string; href: string; children: string }) {
  return (
    <a className={className} href={href} target="_blank" rel="noreferrer" title={href}>
      {children}
    </a>
  );
}

/** "found here: hawthornmedical.com.au/about ↗" — every published contact
    carries the page the crawler read it from, so it can be checked before
    it is used. */
export function FoundHere({ href }: { href: string }) {
  return (
    <ExternalLink className="outreach-found" href={href}>
      {`found here: ${shortUrl(href)} ↗`}
    </ExternalLink>
  );
}

export function SectionHead({
  title,
  count,
  note,
  open,
  onToggle,
}: {
  title: string;
  count: string;
  note: string;
  open: boolean;
  onToggle: () => void;
}) {
  return (
    <button type="button" className="group-head outreach-head" aria-expanded={open} onClick={onToggle}>
      <span className="outreach-caret">{open ? '▾' : '▸'}</span>
      <span className="group-title">{title}</span>
      <span className="group-count">{count}</span>
      <span className="outreach-note">· {note}</span>
    </button>
  );
}

export function OutreachEmpty() {
  return (
    <div className="outreach-empty">
      <div className="et">No leads pushed yet</div>
      <p>
        This tab fills itself. Run <code>/lead-run</code> in the lead scraper and its deliver step
        pushes that week's shortlist and queued leads straight here, dossiers and all.
      </p>
      <p>
        Statuses you set in this tab are the truth from then on. The next run reads them before it
        starts, so a lead you closed as not a fit never comes back.
      </p>
    </div>
  );
}
